import { PageHeader } from "@bednbody/ui/components/page-header";
import { useAuth } from "@/lib/auth";
import { useCurrentMileageRate } from "./mileage.hooks";
import { MileageRequestForm } from "./components/MileageRequestForm";
import { MileageApprovalQueue } from "./components/MileageApprovalQueue";
import { TrackingQualitySection } from "./components/TrackingQualitySection";

export function MileagePage() {
  const { claims } = useAuth();
  const { data: currentRate } = useCurrentMileageRate();

  return (
    <div>
      <PageHeader
        description={
          <>
            Current live rate:{" "}
            <span className="font-medium text-foreground">
              {currentRate != null ? `₱${currentRate}/km` : "-"}
            </span>
          </>
        }
        title="Mileage Rate"
      />

      {claims?.role === "admin" ? <MileageRequestForm /> : null}

      {claims?.role === "executive" || claims?.role === "superadmin" ? (
        <>
          <h2 className="mb-3 mt-6 font-medium">Pending approval</h2>
          <MileageApprovalQueue />
        </>
      ) : null}

      {/* ⚠ ON THIS PAGE BECAUSE THIS IS WHERE DISTANCE-AS-PAY IS REASONED ABOUT,
          and its role list (admin / executive / superadmin, permissions.ts) is
          already the set of people who can act on the Open Item behind it.
          Ungated within the page: an admin who can request a rate change is
          exactly who should see that the distances it multiplies may be short.

          ⚠ NOT on the ops dashboard. This is not a today problem to work
          through — it is a pattern across weeks, and a permanent card there
          would either nag or be tuned out. */}
      <TrackingQualitySection />
    </div>
  );
}
